<template>
  <div class="xz_module_publish">
    <div class="draft-job">
      <h5>主要信息</h5>
    </div>
    <div class="infor_field flexStart">
      <label class="field_name">职位描述:</label>
      <div style="width: 550px;">
        <textarea rows="14" cols="10" placeholder="岗位说明" v-model="entJobExplan" class="jobDetail"></textarea>
        <small>注：要求中请勿填写涉及歧视的内容，例如：残疾，乙肝等</small>
      </div>
    </div>
    <div class="infor_field">
      <label class="field_name must_star">工作薪资:</label>
      <el-radio-group v-model="tabSelected" @change="selectSalay" style="margin-bottom: 30px;">
        <el-radio-button label="月薪"></el-radio-button>
        <el-radio-button label="日薪"></el-radio-button>
        <el-radio-button label="时薪"></el-radio-button>
        <el-radio-button label="计件"></el-radio-button>
        <el-radio-button label="面议"></el-radio-button>
      </el-radio-group>
      <div v-if="tabSelected == '月薪'" style="margin-left:30px">
        <div class="salary_purview" style="margin-left:120px">
          <div>
            <input
              class="xz_salaryInput"
              type="number"
              v-model.number="entJobMinPay.value"
              :class="{'error_alert':entJobMinPay.empty}"
              @blur="checkSalaryEmpty"
            />
            <span class="error_alert_error" v-if="entJobMinPay.empty">请填写最小薪资</span>
          </div>
          <span>千元</span>
          <span class="carpetWord">至</span>
          <div>
            <input
              class="xz_salaryInput"
              type="number"
              v-model.number="entJobMaxPay.value"
              :class="{'error_alert':entJobMaxPay.empty}"
              @blur="checkSalaryEmpty"
            />
            <span class="error_alert_error" v-if="entJobMaxPay.empty">请填写最大薪资</span>
            <span>千元</span>
          </div>
          <span class="carpetWord">*</span>
          <!-- <div>
            <input
              class="xz_salaryInput"
              type="number"
              v-model.number="entJobPayMonth.value"
              :class="{'error_alert':entJobPayMonth.empty}"
              @blur="checkSalaryEmpty"
            />
            <span class="error_alert_error" v-if="entJobPayMonth.empty">月份不能少于12个月</span>
          </div>
          <span>个月</span> -->
          <span>
            =
            <span style="font-size:20px;color:rgb(200, 42, 46) !important;">{{totalSalay}}元/年</span>
          </span>
        </div>
        <span
          v-if="salaryPale"
          class="error_alert_error"
          style="margin-left:150px;"
        >最小薪资不能大于最大薪资，并且最大薪资不能超过最小薪资的三倍</span>
        <small style="margin-top:10px;display:block;margin-left:120px;">注：请输入年薪范围, 最大薪资不能超过最小薪资的3倍</small>
      </div>
      <div v-if="tabSelected == '日薪'" style="margin-left:30px">
        <div class="salary_purview" style="margin-left:120px">
          <input class="xz_salaryInput" type="number" v-model.number="entJobMinPay.value" />
          <span style="line-height:45px;margin-left:10px">/ 天</span>
          <span class="carpetWord">*</span>
          <input
              class="xz_salaryInput"
              type="number"
              v-model.number="entJobPayMonth.value"
            />
          <span>
            =
            <span style="font-size:20px;color:rgb(200, 42, 46) !important;">{{otherSalay}}元/年</span>
          </span>
        </div>
      </div>
      <div v-if="tabSelected == '时薪'" style="margin-left:30px">
        <div class="salary_purview" style="margin-left:120px">
          <input class="xz_salaryInput" type="number" v-model.number="entJobMinPay.value" />
          <span style="line-height:45px;margin-left:10px">元/ 小时</span>
        </div>
      </div>
      <div v-if="tabSelected == '计件'" style="margin-left:30px">
        <div class="salary_purview" style="margin-left:120px">
          <input class="xz_salaryInput" type="number" v-model.number="entJobMinPay.value" />
          <span style="line-height:45px;margin-left:10px">元/ 件</span>
        </div>
      </div>
      <div v-if="tabSelected == '面议'" style="margin-left:30px">
      </div>
    </div>
    <!-- <div class="infor_field">
      <label class="field_name">时薪:</label>
      <div class="salary_purview">
        <div>
          
        </div>
        <span style="line-height:45px;margin-left:10px">/ 小时</span>
      </div>
    </div>-->
    <!-- <div class="infor_field">
      <label class="field_name">佣金:</label>
      <div class="salary_purview">
        <div>
          <input class="xz_salaryInput" type="number" v-model.number="commission" />
        </div>
        <span style="line-height:45px;margin-left:10px">元</span>
      </div>
    </div>-->
    <div class="infor_field flexStart">
      <label class="field_name">职位福利:</label>
      <MultipleSelect
        :options="welfareTag"
        :selected="entWelfareTag"
        @change="selectWelfareTag"
        :custom="true"
      ></MultipleSelect>
    </div>
    <div class="infor_field">
      <label class="field_name">工作经验:</label>
      <div style="width:550px;">
        <el-radio-group v-model="entJobWorkTime" @change="changeExp">
          <el-radio-button
            v-for="(tag,index) in $store.state.PUBLISH.workTimeTag"
            :key="index"
            :label="tag"
          >{{tag}}</el-radio-button>
        </el-radio-group>
      </div>
    </div>
    <div class="infor_field">
      <label class="field_name">学历:</label>
      <div class="eduContainer">
        <el-radio-group v-model="entJobEdu" @change="changeEdu">
          <el-radio-button
            v-for="(tag,index) in $store.state.PUBLISH.eduTag"
            :key="index"
            :label="tag"
          >{{tag}}</el-radio-button>
        </el-radio-group>
        <el-checkbox label="统招" v-model="entJobEduChecked" style="margin-left:10px;"></el-checkbox>
      </div>
    </div>
    <div class="infor_field">
      <label class="field_name">外语:</label>
      <div>
        <!--显示语言等级-->
        <div class="languageRate" v-if="hideRate">
          <el-tag closable @close="clearLanguage">{{otherLanguage ? otherLanguage : language}}</el-tag>
          <el-rate v-model="languageLevel" show-text :texts="levelRate"></el-rate>
        </div>
        <!--选择语言-->
        <el-radio-group v-model="language" @change="selectLanguage">
          <el-radio-button v-for="(tag,index) in languageTag" :key="index" :label="tag">{{tag}}</el-radio-button>
        </el-radio-group>
        <!--自定义语言-->
        <div class="customLanguageContainer" v-if="showCustom">
          <input type="text" class="xz_addTag_input" v-model="custom_language" />
          <button type="button" class="xz_addTag_btn" @click="languagePlus">新增语言</button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
// 多选插件
import MultipleSelect from "../widgets/multipleSelect";
export default {
  components: {
    MultipleSelect,
  },
  data() {
    return {
      tabSelected: "",
      welfareTag: this.$store.state.PUBLISH.welfareTag,
      //福利
      entWelfareTag: [],
      // 工作经验
      entJobWorkTime: "",
      // 学历
      entJobEdu: "",
      // 职位描述
      entJobExplan: "岗位说明：\n\n\n任职要求：\n",
      // 是否是统招
      entJobEduChecked: false,
      // 语言类型
      languageTag: this.$store.state.PUBLISH.languageTag,
      // 语言等级
      levelRate: this.$store.state.PUBLISH.langLevel,
      // 自定义语言
      custom_language: "",
      // 语言
      language: "不限",
      // 添加的其他语言
      otherLanguage: "",
      // 语言等级
      languageLevel: 3,
      // 隐藏评分
      hideRate: true,
      showCustom: false,
      entJobPayMonth: {
        value: 12,
        empty: false,
      },
      entJobMinPay: {
        value: 5,
        empty: false,
      },
      entJobMaxPay: {
        value: 8,
        empty: false,
      },
      // 薪资提示
      salaryPale: false,
      // 佣金
      commission: "",
      // 时薪
      perThing: "",
    };
  },
  mounted() {
    let welfareTag = this.welfareTag;
    welfareTag.forEach((a) => {
      if (a.check === true) a.check = false;
    });
    this.welfareTag = welfareTag;
  },
  watch: {
    language: {
      handler: function () {
        this.showCustom = this.language === "其他";
        if (
          (this.language === "其他" && this.otherLanguage === "") ||
          this.language === "不限"
        ) {
          this.hideRate = false;
        } else {
          this.hideRate = true;
        }
      },
      immediate: true,
    },
    otherLanguage: {
      handler: function () {
        if (
          (this.language === "其他" && this.otherLanguage === "") ||
          this.language === "不限"
        ) {
          this.hideRate = false;
        } else {
          this.hideRate = true;
        }
      },
      immediate: true,
    },
    "$store.state.PUBLISH.jobInfo": {
      handler: function () {
        if (this.$store.state.PUBLISH.jobInfo) {
          const info = this.$store.state.PUBLISH.jobInfo;
          // 描述
          
            if (info.entJobPayMonth == 12) {
              this.tabSelected = '月薪'
            }
            if (info.entJobPayMonth == 0) {
              this.tabSelected = '面议'
            }
            if (info.entJobPayMonth == 24) {
              this.tabSelected = '时薪'
            }
            if (info.entJobPayMonth == 365) {
              this.tabSelected = '日薪'
            }
            if(info.entJobPayMonth == 1000) {
              this.tabSelected = '计件'
            }
          console.log('infopaymonth',info.entJobPayMonth)
          this.entJobExplan = info.entJobExplan;
          this.commission = info.coin;
          this.perThing = info.hourPay;
          this.$set(this.entJobMinPay, "value", info.entJobMinPay);
          this.$set(this.entJobMaxPay, "value", info.entJobMaxPay);
          this.$set(this.entJobPayMonth, "value", info.entJobPayMonth);
          // 语言
          let lang = info.entJobLang[0];
          this.languageLevel = lang.level;
          const inPurview = this.languageTag.find((t) => t === lang.name);
          if (inPurview) {
            this.language = lang.name;
            // 添加的其他语言
            this.otherLanguage = "";
          } else {
            this.language = "其他";
            // 添加的其他语言
            this.otherLanguage = lang.name;
          }
          // 学历
          this.entJobEdu = info.entJobEdu;
          // 工作经验
          this.entJobWorkTime = info.entJobWorkTime;
          // 福利
          this.entWelfareTag = info.entWelfareTag;
        }
      },
      immediate: true,
    },
  },
  computed: {
    otherSalay: function () {
      if (
        !this.entJobMinPay.value ||
        !this.entJobPayMonth.value
      ) {
        return 0;
      }
      const rMin = this.entJobMinPay.value * parseInt(this.entJobPayMonth.value)
      return rMin;
    },
    totalSalay: function () {
      if (
        !this.entJobMinPay.value ||
        !this.entJobMaxPay.value ||
        !this.entJobPayMonth.value
      ) {
        return 0;
      }
      const rMin = (
        (this.entJobMinPay.value * parseInt(this.entJobPayMonth.value)) /
        10
      ).toFixed(1);
      const rMax = (
        (this.entJobMaxPay.value * parseInt(this.entJobPayMonth.value)) /
        10
      ).toFixed(1);
      return rMin + "-" + rMax + "万";
    },
  },
  methods: {
    selectSalay() {
      // console.log("tabSelected",this.tabSelected)
      if (this.tabSelected == "月薪") {
        this.entJobPayMonth.value = 12
      }
      if (this.tabSelected == '日薪') {
        this.entJobPayMonth.value = 365
      }
      if (this.tabSelected == '时薪') {
        this.entJobPayMonth.value = 24
      }
      if (this.tabSelected == '计件') {
        this.entJobPayMonth.value = 1000
      }
      if (this.tabSelected == '面议') {
        this.entJobPayMonth.value = 0
      }
    },
    // 选择福利
    selectWelfareTag(val) {
      this.entWelfareTag = val;
    },
    // 工作经验
    changeExp(v) {
      this.entJobWorkTime = v;
    },
    // 学历
    changeEdu(v) {
      this.entJobEdu = v;
    },
    // 初始化语言
    clearLanguage() {
      this.language = "不限";
      this.languageLevel = 3;
    },
    // 选择语言
    selectLanguage() {
      // 清空其他语言
      this.otherLanguage = "";
    },
    //去除薪资提示
    checkSalaryEmpty() {
      if (this.tabSelected == '月薪') {
        if (!this.entJobMinPay.value) {
        this.$set(this.entJobMinPay, "empty", true);
        return true;
      } else {
        this.$set(this.entJobMinPay, "empty", false);
      }
      if (!this.entJobMaxPay.value) {
        this.$set(this.entJobMaxPay, "empty", true);
        return true;
      } else {
        this.$set(this.entJobMaxPay, "empty", false);
      }
      if (!this.entJobPayMonth.value) {
        this.$set(this.entJobPayMonth, "empty", true);
        return true;
      } else {
        this.$set(this.entJobPayMonth, "empty", false);
      }

      // this.salaryPale = this.entJobMinPay.value > this.entJobMaxPay.value;
      // this.salaryPale = this.entJobMaxPay.value / this.entJobMinPay.value > 3;
      if (
        this.entJobMaxPay.value / this.entJobMinPay.value > 3 || this.entJobMinPay.value > this.entJobMaxPay.value
      ) {
        console.log('有提示111')
        return true;
      }
      if (
        (this.entJobMinPay.value - this.entJobMaxPay.value) > 0
      ) {
        console.log('有提示')
        return true;
      }
      } else {
        console.log('no has')
      }
    },
    //新增语言
    languagePlus() {
      if (!this.custom_language.trim()) return;
      const v = this.custom_language.trim();
      const inArray = this.languageTag.find((t) => t === v);
      if (inArray && v !== "其他") {
        this.language = v;
      } else {
        this.otherLanguage = v;
      }
      this.custom_language = "";
    },

    //返回数据
    returnVal() {
      const full = this.checkFill() ? false : true;
      return {
        entJobExplan: this.entJobExplan,
        entJobMinPay: this.entJobMinPay.value,
        entJobMaxPay: this.entJobMaxPay.value,
        entJobPayMonth: this.entJobPayMonth.value,
        entJobLang: JSON.stringify([
          {
            name: this.otherLanguage ? this.otherLanguage : this.language,
            level: this.languageLevel,
          },
        ]),
        perThing: this.perThing,
        commission: this.commission,
        entWelfareTag: this.entWelfareTag,
        entJobWorkTime: this.entJobWorkTime,
        entJobEdu: this.entJobEdu,
        status: full,
      };
    },
    // 检查必填项
    checkFill() {
      return this.checkSalaryEmpty();
    },
  },
};
</script>
<style scoped>
.customLanguageContainer {
  width: 100%;
  display: flex;
  margin-top: 10px;
}
.xz_addTag_btn {
  border: 1px solid #ddd;
  border-radius: 5px;
  cursor: pointer;
  height: 40px;
  display: inline-block;
  color: #333;
  font-size: 14px;
  padding: 0 17px;
  outline: none;
}
.xz_addTag_btn:hover {
  border: 1px solid #409eff;
  background: #409eff;
  color: #fff;
}
.xz_addTag_input {
  width: 200px;
  border: 1px solid #ddd;
  border-radius: 6px;
  height: 40px;
  font-size: 14px;
  padding: 0 15px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  outline: none;
  margin-right: 10px;
}
.salary_purview {
  width: 650px;
  display: flex;
}
.xz_salaryInput {
  width: 82px;
}
.salary_purview span {
  line-height: 45px;
}
.carpetWord {
  margin: 0 6px;
}
.languageRate {
  display: flex;
  margin-bottom: 10px;
}
</style>
<style>
@import url("../../assets/css/module_publish.css");
</style>